import React, { useEffect, useState } from 'react';

import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  Modal,
  NamedLink,
} from '../../components';
import {BottleRatingReview} from '../../components/review/Bottle';

import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './WineryPlansPage.module.css';
import pattern from './pattern.png';
import Plans from './Plans';
import { getPlans } from '../../services/plan';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';


const WineryPlansPage = ({
  currentUser,
  wineryOwner,
  admin,
  onManageDisableScrolling,
  history,
}) => {
  const [plans, setPlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState([]);
  const [tosModalOpen, setTosModelOpen] = useState(false);

  useEffect(() => {
    getPlans(setPlansLoading, setPlans)
  }, []);

  const handleOnClickSubscribe = () => {
    if(currentUser === null || !wineryOwner) {
      setTosModelOpen(true)
    } else if(wineryOwner) {
      history.push('/manage-subscriptions-settings')
    }
  }

  return (
    <StaticPage
      title="Winery Plans"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WineryPlansPage',
        description: 'Winery Plans Page',
        name: 'WineryPlansPage',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>

            <div className={css.layoutWrapperHeader}>
              <div className={css.overlay} />
              <div className={css.headerContent}>
                <h1>Winery Plans & Pricing</h1>
                <h3>
                  Get discovered and sell more wine direct
                </h3>
              </div>
            </div>

            <div className={css.secondSectionWrapper}>
              <div className={css.pattern}>
                <img src={pattern} alt="" />
              </div>

              <div className={css.secondSectionContainer}>
                <h4>
                  Amplify the reach of your winery with the Sommly platform, purpose built to drive direct wine sales digitally. No upfront investment is required for access to this new direct to consumer eCommerce channel.
                  <br /> <br />
                  Consumers increasingly prefer to purchase wine online, and from local, smaller production brands not often available in retail. Join the community of artisanal wineries and join Sommly’s digital marketplace in one of three easy plans!

                </h4>
              </div>
            </div>

            <div className={css.sommlyPlansWrapper}>
              <Plans
                plans={plans}
                plansLoading={plansLoading}
                handleOnClickSubscribe={handleOnClickSubscribe}
              />
            </div>
          </div>

          <Modal
            id="subscription"
            isOpen={tosModalOpen}
            onClose={() => setTosModelOpen(false)}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
          >
            <div className={css.termsWrapper}>
              {currentUser === null ? (
                <>
                <h4>
                  Please login to have the option to select the Sommly subscription plan that's right for you.
                </h4>
                <NamedLink name="LoginPage">
                  Login here
                </NamedLink>
                </>
              ) : (
                <>
                  {!wineryOwner && !admin ? (
                    <h4>
                      Please claim your winery's page.  Once we've approved your Winery Claim request, you'll be notified, and will have the option to select the Sommly subscription plan that's right for you. You can find your subscription options from within the My Winery page on your profile.
                    </h4>
                  ) : null}
                  {admin ? (
                    <h4>
                      It seems you are an admin of the platform, please login with the email you would like to select the Sommly subscription plan for that.
                    </h4>
                  ) : null}
                </>
              )}
            </div>
          </Modal>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { admin, wineryOwner } = state.Auth;
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    admin,
    wineryOwner,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  // injectIntl
)(WineryPlansPage);
// export default WineryPlansPage;
